import pizzaImage from 'assets/images/img-pizza-for-ten.png';

const PizzaOffer = () => (
  <svg width="132" height="129" viewBox="0 0 132 129" fill="none">
    <path
      d="M9.84021 91.4769C-0.874056 74.0629 -2.94683 50.9949 6.39538 31.9761C8.91748 26.841 12.7876 22.5002 16.7486 18.3707C21.5093 13.404 26.5588 8.57648 32.59 5.26805C46.2944 -2.25279 69.4667 -0.361881 84.1473 2.61757C157.227 17.4587 141.982 145.54 64.5883 127.209C51.0203 123.994 38.7307 116.861 27.0296 109.279C19.9928 104.716 14.1997 98.5645 9.84021 91.4769Z"
      fill="url(#pattern0_1597_2287)"
    />
    <defs>
      <pattern id="pattern0_1597_2287" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use
          xlinkHref="#image0_1597_2287"
          transform="matrix(0.00078125 0 0 0.000793906 0 -0.262149)"
        />
      </pattern>
      <image id="image0_1597_2287" width="1280" height="1920" xlinkHref={pizzaImage} />
    </defs>
  </svg>
);

export default PizzaOffer;
